// extracted by mini-css-extract-plugin
module.exports = {"root":"ClearentDisclaimer_root__1SpYe","header":"ClearentDisclaimer_header__3UO2I","inner":"ClearentDisclaimer_inner__TdDOU"};